export * from './alert-box/AlertBoxComponent';
export * from './paginator/PaginatorComponent';


// WEBPACK FOOTER //
// ./src/common/modules/shared/components/index.ts